<template>
<span>
  <v-text-field ref="numberField" v-model="model" :label="label" type="number"></v-text-field>
  {{ description }}
</span>
</template>

<script>
import {
  input
} from '@/mixins/input'
import InputNumberValidator from '@/plugins/validator/number/InputNumberValidator'
import {
  observerField
} from '@/mixins/observerField'

export default {
  mixins: [input, observerField],
  data() {
    return {
      validator: undefined
    }
  },
  mounted() {
    if (this.field.options && this.field.options.expanded) {
      this.validator = new InputNumberValidator(this, this.$refs.numberField.$refs.input, this.field, this.context)
      this.registerValidatorWatcher()
    }
  },
  methods: {
    registerValidatorWatcher() {
      this.$watch('changedContextData', function () {
        this.validator.matchAndValidate()
      }, {
        deep: true
      });
    },
    beforeSend(val) {
      val = String(val).replace(",", ".")
      return +val
    }
  }
}
</script>

<style>
</style>
